var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"promts_edit\"\u003E\u003Cpromt-form v-if=\"ready\" :init-data=\"data\" :errors=\"errors\" @submit=\"updatePromt\"\u003E\u003C\u002Fpromt-form\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;